import { createSelector } from 'reselect'
import { Address, Customer, Wallet } from 'types/Customer'

export const getCustomer = (state: Record<string, any>): Customer => state.customer || {}

export const getCustomerEmail = createSelector([getCustomer], ({ email }): string => email || '')

export const getCustomerIsExisting = createSelector(
  [getCustomer],
  ({ isExisting }): boolean => isExisting || false
)

export const getCustomerId = createSelector(
  [getCustomer],
  ({ customerId }): string => customerId || ''
)

export const getCustomerAddressBook = createSelector(
  [getCustomer],
  ({ addressBook }): Address[] => addressBook || []
)

export const getCustomerWallet = createSelector(
  [getCustomer],
  ({ wallet }): Wallet[] => wallet || []
)

export const getCustomerWalletItemsCount = createSelector(
  [getCustomerWallet],
  (wallet): number => wallet.length || 0
)

export const getCustomerAddressBookItemByIdOrNull = (addressBookItemId: string) =>
  createSelector([getCustomerAddressBook], (addressBook) => {
    return addressBook.find((item) => item.addressBookItemId === addressBookItemId) || undefined
  })

export const getCustomerAddressBookItemById = (addressBookItemId: string): Address | {} =>
  createSelector([getCustomerAddressBook], (addressBook) => {
    return addressBook.find((item) => item.addressBookItemId === addressBookItemId) || {}
  })

export const getCustomerWalletItemById = (paymentMethodId: string): Wallet | {} =>
  createSelector([getCustomerWallet], (wallet) => {
    return wallet.find((item) => item.paymentMethodId === paymentMethodId) || {}
  })
